export default "__VITE_ASSET__D7n9j1kA__"